<header class="bg-image bg-image-sec">
    <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white shadow-sm">
        <div class="container">
            <a class="navbar-brand" routerLink="/">
                <!-- <img src="../../../../assets/images/header-logo.png" /> -->
                <img src="../../../assets/images/enl-solutions-logo-new.png" class="enl-logo" />
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto"></ul>
                <div class="form-inline my-2 my-lg-0">
                </div>
            </div>
        </div>
    </nav>
</header>

<section class="login-section">
    <div class="login-section-inner">
        <div class="login-left">
            <h2>Hello!</h2>
            <div class="login-acc">
                Please send email to change your Password.
            </div>
        </div>
        <div class="login-right">
            <div *ngIf="isSuccess == false">
                <form class="form-card" [formGroup]="forgotForm">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- <img src="../../../../assets/images/innerLogo.png" class="login-logo" /> -->
                            <img src="../../../assets/images/enl-solutions-logo-new.png" class="enl-logo" />
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="section-relative">
                                    <input type="email" formControlName="userName" class="form-control" id="InputEmail"
                                        aria-describedby="emailHelp" placeholder="Enter Email" />
                                    <img src="../../../../assets/images/user.svg" class="user-icon" />

                                    <div *ngIf="hasError('userName', 'required') && submitted"
                                        class="invalid-Validation">
                                        Email is required
                                    </div>
                                    <div *ngIf="hasError('userName', 'email') && submitted" class="invalid-Validation">
                                        Invalid Email
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="btn-login-sec">
                                <button class="btn btn-signIn" type="submit" (click)="sendEmail()">
                                    SEND EMAIL
                                </button>
                                <a routerLink="/login" class="btn btn-signIn btn-signUp">
                                    SIGN IN
                                </a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div *ngIf="isSuccess == true">
                <div class="row">
                    <div class="col-md-12">
                        <!-- <img src="../../../../assets/images/innerLogo.png" class="login-logo" /> -->
                        <img src="../../../assets/images/enl-solutions-logo-new.png" class="enl-logo" />
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <h2>Email sent successfully, please check your email.</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>